import { apiGetYearGroups } from '../../common/api/year-groops'

const fetchYearGroups = () => ({
  requestPrefix: 'YEAR_GROUPS:FETCHING',
  request: () =>
    apiGetYearGroups({ include: 'year_group.names,year_group.order' })
})

export { fetchYearGroups }
